export { default, loader } from "~/components/brandCustomPage/banners/BrandBannerMosaic"

// 5-banner mosaic on the home — reserve real grid height to prevent CLS.
// Desktop: 2 rows of banners (~600px each row). Mobile: 5 stacked (~200px each).
export function LoadingFallback() {
  return <div className='w-full min-h-[800px] bg-base-200/30 animate-pulse' />
}
